// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../node_modules/rescript/lib/es6/curry.js";
import * as Caml_format from "../../../../../node_modules/rescript/lib/es6/caml_format.js";
import * as FlatResult$Catalyst from "../../../../../node_modules/@porterin/catalyst/src/helper-modules/reasonML/FlatResult.bs.js";
import * as ReMapUtils$Catalyst from "../../../../../node_modules/@porterin/catalyst/src/utils/ReMapUtils.bs.js";

function validateMsisdn(csvRowResult) {
  try {
    var cell = Curry._2(ReMapUtils$Catalyst.StringMap.find, "driver_msisdn", csvRowResult);
    if (cell.TAG !== /* Ok */0) {
      return {
              TAG: /* Error */1,
              _0: cell._0
            };
    }
    var msisdn = cell._0;
    if (msisdn.TAG === /* Msisdn */2) {
      return {
              TAG: /* Ok */0,
              _0: msisdn._0
            };
    } else {
      return {
              TAG: /* Error */1,
              _0: "driver_msisdn not valid"
            };
    }
  }
  catch (exn){
    return {
            TAG: /* Error */1,
            _0: "driver_msisdn not found"
          };
  }
}

function validateVehicleNumber(csvRowResult) {
  try {
    var cell = Curry._2(ReMapUtils$Catalyst.StringMap.find, "vehicle_number", csvRowResult);
    if (cell.TAG !== /* Ok */0) {
      return {
              TAG: /* Error */1,
              _0: cell._0
            };
    }
    var vehicleNumber = cell._0;
    if (vehicleNumber.TAG === /* String */0) {
      return {
              TAG: /* Ok */0,
              _0: vehicleNumber._0
            };
    } else {
      return {
              TAG: /* Error */1,
              _0: "vehicle_number not valid"
            };
    }
  }
  catch (exn){
    return {
            TAG: /* Error */1,
            _0: "vehicle_number not found"
          };
  }
}

function validateAmount(csvRowResult) {
  try {
    var cell = Curry._2(ReMapUtils$Catalyst.StringMap.find, "amount", csvRowResult);
    if (cell.TAG !== /* Ok */0) {
      return {
              TAG: /* Error */1,
              _0: cell._0
            };
    }
    var amount = cell._0;
    if (amount.TAG !== /* Number */1) {
      return {
              TAG: /* Error */1,
              _0: "amount not valid"
            };
    }
    var amount$1 = amount._0;
    var value = Caml_format.caml_int_of_string(amount$1);
    if (value > 0) {
      return {
              TAG: /* Ok */0,
              _0: amount$1
            };
    } else {
      return {
              TAG: /* Error */1,
              _0: "amount should be positive"
            };
    }
  }
  catch (exn){
    return {
            TAG: /* Error */1,
            _0: "amount not found"
          };
  }
}

function validatePartnerComment(csvRowResult) {
  try {
    var cell = Curry._2(ReMapUtils$Catalyst.StringMap.find, "partner_comment", csvRowResult);
    if (cell.TAG !== /* Ok */0) {
      return {
              TAG: /* Error */1,
              _0: cell._0
            };
    }
    var comment = cell._0;
    if (comment.TAG !== /* String */0) {
      return {
              TAG: /* Error */1,
              _0: "partner_comment not valid"
            };
    }
    var comment$1 = comment._0;
    var length = comment$1.length;
    if (length > 0 && length < 256) {
      return {
              TAG: /* Ok */0,
              _0: comment$1
            };
    } else {
      return {
              TAG: /* Error */1,
              _0: "partner_comment is required and less than 256 characters"
            };
    }
  }
  catch (exn){
    return {
            TAG: /* Error */1,
            _0: "partner_comment not found"
          };
  }
}

function validateAdminComment(csvRowResult) {
  try {
    var cell = Curry._2(ReMapUtils$Catalyst.StringMap.find, "admin_comment", csvRowResult);
    if (cell.TAG !== /* Ok */0) {
      return {
              TAG: /* Error */1,
              _0: cell._0
            };
    }
    var comment = cell._0;
    if (comment.TAG !== /* String */0) {
      return {
              TAG: /* Error */1,
              _0: "admin_comment not valid"
            };
    }
    var comment$1 = comment._0;
    var length = comment$1.length;
    if (length > 0 && length < 256) {
      return {
              TAG: /* Ok */0,
              _0: comment$1
            };
    } else {
      return {
              TAG: /* Error */1,
              _0: "admin_comment is required and less than 256 characters"
            };
    }
  }
  catch (exn){
    return {
            TAG: /* Error */1,
            _0: "admin_comment not found"
          };
  }
}

function map(csvRowResult) {
  return FlatResult$Catalyst.let_(validateMsisdn(csvRowResult), (function (msisdn) {
                return FlatResult$Catalyst.let_(validateVehicleNumber(csvRowResult), (function (vehicleNumber) {
                              return FlatResult$Catalyst.let_(validateAmount(csvRowResult), (function (amount) {
                                            return FlatResult$Catalyst.let_(validatePartnerComment(csvRowResult), (function (partner_comment) {
                                                          return FlatResult$Catalyst.let_(validateAdminComment(csvRowResult), (function (admin_comment) {
                                                                        return {
                                                                                TAG: /* Ok */0,
                                                                                _0: {
                                                                                  driver_msisdn: msisdn,
                                                                                  vehicle_number: vehicleNumber,
                                                                                  amount: Caml_format.caml_float_of_string(amount),
                                                                                  partner_comment: partner_comment,
                                                                                  admin_comment: admin_comment
                                                                                }
                                                                              };
                                                                      }));
                                                        }));
                                          }));
                            }));
              }));
}

export {
  validateMsisdn ,
  validateVehicleNumber ,
  validateAmount ,
  validatePartnerComment ,
  validateAdminComment ,
  map ,
  
}
/* ReMapUtils-Catalyst Not a pure module */
